// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// main.tsx or App.tsx
import { ConfigProvider } from 'antd';


// Local reset (bootstrap is injected dynamically by ThemeContext)
// import './assets/styles/buttons.scss'
import 'antd/dist/reset.css';
import 'react-toastify/dist/ReactToastify.css';
import './index.scss';
import '@fontsource/vazirmatn/400.css';
import '@fontsource/vazirmatn/500.css';
import '@fontsource/vazirmatn/700.css';
// Persian font (Vazirmatn)
import '@fontsource/vazirmatn/400.css';
import '@fontsource/vazirmatn/500.css';
import '@fontsource/vazirmatn/700.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ConfigProvider

    >
      <App />
    </ConfigProvider>
  </React.StrictMode>
);

// src/index.js
// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import App from './App';
// import { ConfigProvider } from 'antd';
// import { ThemeProvider, useTheme } from './context/ThemeContext';
// import { lightTheme, darkTheme } from './assets/styles/theme/theme';

// import 'antd/dist/reset.css';
// import 'react-toastify/dist/ReactToastify.css';
// import './index.scss';

// // Persian font (Vazirmatn)
// import '@fontsource/vazirmatn/400.css';
// import '@fontsource/vazirmatn/500.css';
// import '@fontsource/vazirmatn/700.css';

// /* =====================================================
//    Bridge: reads ThemeContext and feeds AntD's ConfigProvider
//    ===================================================== */
// function AntdThemeBridge({ children }) {
//   const { isDark } = useTheme();
//   return (
//     <ConfigProvider theme={isDark ? darkTheme : lightTheme}>
//       {children}
//     </ConfigProvider>
//   );
// }

// /* =====================================================
//    Mount
//    ===================================================== */
// const root = ReactDOM.createRoot(document.getElementById('root'));

// root.render(
//   <React.StrictMode>
//     <ThemeProvider>
//       <AntdThemeBridge>
//         <App />
//       </AntdThemeBridge>
//     </ThemeProvider>
//   </React.StrictMode>
// );